/*
 * @Author: iRuxu
 * @Date: 2022-06-16 18:33:46
 * @LastEditTime: 2022-06-20 15:37:39
 * @Description: 拦截器
 */

import { ElMessage, ElMessageBox, ElNotification } from "element-plus";

function loadPop(msg, popType = "message") {
    switch (popType) {
        case "message":
            ElMessage({
                message: msg,
                type: "error",
            });
            break;
        case "alert":
            ElMessageBox.alert(msg, "错误");
            break;
        case "notify":
            ElNotification({
                title: "错误",
                message: msg,
                duration: 3000,
            });
            break;
        default:
            break;
    }
}

/**
 * 标准统一包装模式
 *
 * @param {*} target
 * @param {*} options
 */
function installStandardInterceptors(target, options) {
    let popType = (options && options.popType) || "message";
    const isMuted = (config) => options?.mute || config?.mute;
    target["interceptors"]["response"].use(
        function (response) {
            if (response.data.code) {
                if (!isMuted(response.config)) {
                    response.data.msg && loadPop(`[${response.data.code}]${response.data.msg}`, popType);
                }
                // code = -2 为已过期
                if (response.data.code === -2) {
                    localStorage.removeItem("token");
                    wx.miniProgram.postMessage({ type: "logout" });
                    wx.miniProgram.navigateTo({ url: "/pages/index/index?login=1" });
                }
                return Promise.reject(response);
            }
            return response;
        },
        function (err) {
            if (!isMuted(err.config)) {
                if (err.response && err.response.data && err.response.data.msg) {
                    loadPop(err.response.data.msg, popType);
                } else {
                    loadPop("请求异常，请稍后重试", popType);
                }
            }
            return Promise.reject(err);
        }
    );
}

export { installStandardInterceptors, loadPop };
